'use strict';

bbw.model.Feed = bbw.model.PubPostsManager.extend({

    perPage: 50,

    _constructPostCollection: function() {
        return this._modelFactory.create(bbw.model.FeedItemCollection);
    },

    setAll: function(all, filter) {
        this.mode.all = !!all;
        this.mode.filter = all ? filter : undefined;
        return this;
    },

    setGlobal: function(isGlobal) {
        this.setAll(false, undefined);
        this.mode.global = true;
        return this;
    },

    setFilter: function(filter) {
        this.mode.filter = filter || undefined;
        return this;
    },

    _configurePostsModel: function() {
        this.mode = {
            all: false
        };
        this._posts.configure({
            'limit': this.perPage
        });
    },

    _hasSubtypes: function() {
        return false;
    },

    _getLoadPostsArgs: function(limit) {
        if (this.mode.global) {
            return {
                global: true,
                limit: true
            };
        }
        return {
            all: this.mode.all ? 1 : 0,
            filter: this.mode.filter,
            limit: limit
        };
    }

});
